import { TabInput } from "./TabInput";
import { TabLabel } from "./TabLabel";
import Carousel from "../carousel/Carousel";
import { carouselOptions } from "../../config";
import 'regenerator-runtime/runtime';

class TabSlider {
    constructor(DOMelement, index, store) {
      try {
        this.el = DOMelement;
        this.index = index;
        this.tabs = this.el.querySelectorAll(".tab-slider-content");
        this.createTabs = this.createTabs.bind(this);      
        this.labelUl = `<div class="sd-tabs-slider__tabs"></div>`;

        if(this.tabs.length == 1){
          this.tabs[0].style.display = "block";
        }
        
        if(this.tabs.length > 1){
          this.tabs.forEach(async (tab) => {
            await this.createTabs(tab);
          });
          const input = this.el.querySelectorAll("input");
          input[0].checked = "true";
        }
        
        const carousels = document.querySelectorAll(".sd-tab-carousel");      
        [...carousels].forEach(carousel => {
          carousel.insertAdjacentHTML("afterbegin", '<button class="sd-carousel__previous" type="button" aria-label="previous-slide"></button>');
          carousel.insertAdjacentHTML("beforeend", '<button class="sd-carousel__next" type="button" aria-label="next-slide"></button>');
          return new Carousel(carousel, store, carouselOptions[`#${carousel.id}`] || {})
        });
        
        window.addEventListener('resize', function(event) {
            [...carousels].forEach(carousel => {
              return new Carousel(carousel, store, carouselOptions[`#${carousel.id}`] || {})
            }
          );
        }, true);
      } catch (error) {
        console.log(error);
      }
    }

    createTabs(data){
      const labelId = data.getAttribute("data-label");
      const labelVal = data.getAttribute("data-label").split('-').join(' ');
      this.tabs[0].insertAdjacentHTML("beforebegin", TabInput(labelId, this.index));
      this.tabs[0].insertAdjacentHTML("beforebegin", TabLabel(labelId, labelVal));
    }
}
export default TabSlider;